
<nav class="navbar-custom navbar navbar-expand-lg bg-dark navbar-dark">
    <img alt="Paie Push logo" class="logo" (click)="this.router.navigateByUrl('/home')"
    src="../../assets/logo.png">
  <a class="navbar-brand" routerLink="/home" ></a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="collapsibleNavbar">
    <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
      <li *ngIf="this.authenService.isMarchant" class="nav-item"  [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
        <a class="nav-link"  routerLink="/commerces" >
          Commerces
      </a>
      </li>
      <li *ngIf="this.authenService.isMarchant" class="nav-item"  [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
        <a class="nav-link"  routerLink="/coupons" >
          Coupons
      </a>
      </li>

      <li *ngIf="this.authenService.isSupperAdmin" class="nav-item"  [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
        <a class="nav-link"  routerLink="/tenants">
          <i>Tenants</i>
        </a>
      </li>
      <li *ngIf="this.authenService.isAdmin || this.authenService.isSupperAdmin" class="nav-item"  [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
        <a class="nav-link" routerLink="/users">
          Utilisateurs
        </a>
      </li>
      <li *ngIf="this.authenService.isAdmin" class="nav-item"  [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
        <a class="nav-link" routerLink="/equipe">
          Agents
        </a>
      </li>
      <li *ngIf="this.authenService.isAdmin" class="nav-item"  [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
        <a class="nav-link"  routerLink="/map">
          Carte
        </a>
      </li>
      <li *ngIf="this.authenService.isAdmin" class="nav-item"  [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
        <a class="nav-link"  routerLink="/administration">
          Places
        </a>
      </li>
      <li *ngIf="this.authenService.isAdmin || this.authenService.isSupperAdmin" class="nav-item"  [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
        <a class="nav-link"  routerLink="/zones">
          Zones
        </a>
      </li>
      <li *ngIf="this.authenService.isAdmin || this.authenService.isSupperAdmin" class="nav-item"  [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
        <a class="nav-link"  routerLink="/display">
          Panneaux <br/>Jalonnement
        </a>
      </li>
      
      <li *ngIf="this.authenService.isAdmin" class="nav-item"  [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
        <a class="nav-link"  routerLink="/configurations">
          Configuration <br/> des places
        </a>
      </li>

      <li *ngIf="this.authenService.isUser || this.authenService.isAdmin" class="nav-item"  [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
        <a class="nav-link"  routerLink="/events" >
          Alertes
      </a>
      </li>
      <li *ngIf="this.authenService.isUser || this.authenService.isAdmin" class="nav-item"  [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
        <a class="nav-link"  routerLink="/stats" >
        Statistiques
      </a>
      </li>
      <li *ngIf="this.authenService.isUser || this.authenService.isAdmin" class="nav-item"  [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
        <a class="nav-link"  routerLink="/compta" >
        Compta
      </a>
      </li>
      <li *ngIf="this.authenService.isUser" class="nav-item"  [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
        <a class="nav-link"  routerLink="/contact" >
          <b>{{this.currentUser?.tenantName}}</b>
        </a>
      </li>
    </ul>
    <ul class="nav navbar-nav ">
      <li class="nav-item"  *ngIf="!this.authenService.isAuthenticated()" routerLink="/login">
        <a class="nav-link" href="#">
          <i class="fa fa-user" aria-hidden="true"></i>
           Se connecter
        </a>
      </li>
      <li *ngIf="this.authenService.isAuthenticated()" class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button"
           data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-user-circle-o" aria-hidden="true"></i>
            {{currentUser.firstname? currentUser.firstname: currentUser.login}}
          </a>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
            <a *ngIf="this.authenService.isMarchant" class="dropdown-item" (click)="profil()" >Mon profil</a>
            <a class="dropdown-item" (click)="changePass()" >Changer Mon Mot de passe</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" (click)="logout()" > Se déconnecter</a>
          </div>
        </li>
      </ul>
  </div>
</nav>
